import { useEffect } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { updateUserSchema } from '../utils/validation/updateUserSchema';
import { useLoggedinUser } from '../../auth/hooks/queries/authQueries';
import { RHFTextField } from '../../../components/RHF';
import DynamicBreadcrumbs from 'components/Breadcrumbs';


export default function MyAccount() {
    const { isLoading, data: loggedinUser } = useLoggedinUser();
    const methods = useForm({
        resolver: yupResolver(updateUserSchema),
        defaultValues: {
            name: '',
            email: '',
            phone_number: ''
        }
    });

    useEffect(() => {
        if (loggedinUser) {
            methods.reset({
                name: loggedinUser.name || '',
                email: loggedinUser.email_address || '',
                phone_number: loggedinUser.phone_number || ''
            });
        }
    }, [isLoading, loggedinUser, methods]);

    const onSubmit = async (formData: any) => {
        console.log("formData ==== ", formData);
    };

    return (
        <div>
            <DynamicBreadcrumbs
                items={[
                    { label: 'Home', href: '/stores' },
                    { label: 'My Account', isCurrent: true }
                ]}
            /><div className="mb-20">
                <p className="list-heading">
                    My Account
                </p>
            </div>
            <div className="add-store-container">
                <div className="add-store-form-container p-24">
                    <FormProvider {...methods}>
                        <form onSubmit={methods.handleSubmit(onSubmit)}>
                            <div className="d-flex flex-column gap-20">
                                <form onSubmit={methods.handleSubmit(onSubmit)}>
                                    <div className="store-form-header">
                                        <p className="store-form-header-text">Personal Information</p>
                                    </div>
                                    <div className="divider-8-24" />

                                    <div className="store-form-fields">
                                        <p className="store-form-fields-text">Name</p>
                                        <RHFTextField name="name" placeholder="John Doe" disabled={true} />
                                    </div>

                                    <div className="store-form-fields">
                                        <p className="store-form-fields-text">Email Address</p>
                                        <RHFTextField name="email" placeholder="dumy@gmail.com" disabled={true} />
                                    </div>

                                    <div className="store-form-fields">
                                        <p className="store-form-fields-text">Phone Number</p>
                                        <RHFTextField name="phone_number" placeholder="7894561235" disabled={true} />
                                    </div>
                                </form>
                            </div>
                        </form>
                    </FormProvider>
                </div>
            </div>
        </div>
    );
} 